import { useContext } from 'react';

import { FeaturesFlagsContext } from '@components/FeaturesFlagsProvider';
import { FeaturesFlagsContextType } from '@components/FeaturesFlagsProvider/FeaturesFlagsProvider.decl';

export function useFeaturesFlags(): FeaturesFlagsContextType {
  return useContext(FeaturesFlagsContext);
}
